import { Edit2, Trash2, ChevronDown, Clock, Users } from "lucide-react";
import { getMealCategories } from "../../utils/mealUtils";

const TAG_COLORS = [
  "bg-purple-50 text-purple-700",
  "bg-teal-50 text-teal-700",
  "bg-amber-50 text-amber-700",
  "bg-pink-50 text-pink-700",
];

export function UserMealListRow({
  meal,
  handleRemoveMeal,
  handleEdit,
  isExpanded,
  onToggle,
}) {
  const categories = getMealCategories(meal);

  return (
    <div className="p-4">
      {/* Top row: name + action buttons */}
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-medium text-gray-900 pt-0.5 min-w-0 flex-1">
          {meal.mealName}
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={() => handleEdit(meal.mealId)}
            aria-label={`Edit ${meal.mealName}`}
            className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 active:bg-blue-200 transition-colors"
          >
            <Edit2 className="w-3.5 h-3.5" />
          </button>
          <button
            type="button"
            onClick={() => handleRemoveMeal(meal.mealId)}
            aria-label={`Delete ${meal.mealName}`}
            className="flex items-center justify-center w-8 h-8 rounded-lg bg-red-50 text-red-500 hover:bg-red-100 active:bg-red-200 transition-colors"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      {/* Meta row: time, servings, categories, tags */}
      <div className="flex items-center flex-wrap gap-1.5 mt-2">
        {meal.timeMins && (
          <span className="inline-flex items-center gap-1 text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
            <Clock className="w-3 h-3" />
            {meal.timeMins} min
          </span>
        )}
        {meal.servings && (
          <span className="inline-flex items-center gap-1 text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
            <Users className="w-3 h-3" />
            {meal.servings}
          </span>
        )}
        {categories.map((cat) => (
          <span
            key={cat}
            className="text-xs px-2 py-1 rounded-full bg-blue-50 text-blue-700"
          >
            {cat}
          </span>
        ))}
        {meal.mealTagList?.map((tag, idx) => (
          <span
            key={tag.tagId}
            className={`text-xs px-2 py-1 rounded-full ${TAG_COLORS[idx % TAG_COLORS.length]}`}
          >
            {tag.tagContent}
          </span>
        ))}
      </div>

      {/* Expand toggle */}
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center gap-1 mt-3 text-xs text-gray-400 hover:text-gray-600 transition-colors"
      >
        {meal.ingredientList?.length ?? 0} ingredients
        <ChevronDown
          className={`w-3.5 h-3.5 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}
        />
      </button>
    </div>
  );
}
